export { default } from './InputDateWithMagnifier';
